/** How far a hand-drawn arrow's ends stop short of the boxes they join, in px: the arrowhead reads as
 *  landing on its target, and the tail as leaving its source, without touching either. */
export const ARROW_GAP_PX = 8;
